import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollToHashTarget } from '@/lib/scrollToHash'

/** Scroll to top on route change, or to a hash target when the URL includes #anchor. */
export function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      return scrollToHashTarget(hash)
    }
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
